import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { EmptyState } from './shared';

export const ShippingSection = ({ shippingSettings, setShippingSettings, onSave, saving }) => {
  if (!shippingSettings) return <EmptyState message="Kunde inte ladda fraktinställningar" />;
  const classPrices = shippingSettings.class_prices || {};

  return (
    <div className="space-y-6" data-testid="admin-shipping">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="font-bold text-[#0F172A] mb-4">Fraktklasser</h3>
        <div className="grid md:grid-cols-5 gap-4">
          {['small', 'medium', 'large', 'bulky', 'pallet'].map((classType) => (
            <div key={classType} className="bg-gray-50 p-4 rounded-lg">
              <Label>{classType === 'small' ? 'Litet' : classType === 'medium' ? 'Mellan' : classType === 'large' ? 'Stort' : classType === 'bulky' ? 'Skrymmande' : 'Pall'}</Label>
              <div className="flex items-center mt-2">
                <Input
                  type="number"
                  value={classPrices[classType] || 0}
                  onChange={(e) => setShippingSettings({ ...shippingSettings, class_prices: { ...classPrices, [classType]: parseFloat(e.target.value) } })}
                  className="w-24"
                />
                <span className="ml-2 text-gray-500">kr</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Button className="bg-[#003B73]" onClick={onSave} disabled={saving}>
        {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
        Spara fraktinställningar
      </Button>
    </div>
  );
};
